<template>
  <span v-if="locator" :title="locator.description?locator.description:''">
         <b-badge variant="danger" v-if="negate">Negated</b-badge>

        <template v-if="typeof locator === 'object'">
        <span v-if="'localnets' in locator">
          <b-badge pill :style="'background-color:'+'localnets'.toHSL()">Localnets</b-badge>
          &nbsp;<code>{{ locator.localnets }}</code>
        </span>
        <span v-else-if="'macro' in locator">
          <b-badge pill :style="'background-color:'+'macro'.toHSL()">Macro</b-badge>
          &nbsp;<code>{{ locator.macro }}</code>
        </span>
        <span v-else-if="'network' in locator">
          <b-badge pill :style="'background-color:'+'network'.toHSL()">Network</b-badge>
          &nbsp;<code>{{ locator.network }}</code>
        </span>
        <span v-else-if="'address' in locator">
          <b-badge pill :style="'background-color:'+'address'.toHSL()">Address</b-badge>
          &nbsp;<code>{{ locator.address }}</code></span>
        <span v-else-if="'bcd' in locator">
          <b-badge pill :style="'background-color:'+'bcd'.toHSL()">BCD</b-badge>
          &nbsp;<b-link :to="`/nws/bcds/${locator.bcd}`">{{ locator.bcd }}</b-link>
        </span>
        <span v-else-if="'locator_group' in locator">
          <b-badge pill :style="'background-color:'+'locator_group'.toHSL()">Locator Group</b-badge>
          &nbsp;<code>{{ locator.locator_group }}</code>
        </span>
        <span v-else-if="'any' in locator">
          <b-badge pill :style="'background-color:'+'any_loc'.toHSL()">Any</b-badge>
          &nbsp;<code>{{ locator.any }}</code>
        </span>
        <span v-else> {{ JSON.stringify(locator) }}</span>
        </template>
        <span v-else> {{ JSON.stringify(locator) }}</span>
    <span>&nbsp;</span>
  </span>
</template>

<script>

export default {
  name: 'FWMLv2LocatorViz',
  props: {
    locator: {
      type: Object,
      required: true
    },
    negate: {
      type: Boolean,
      required: true
    }
  },
}
</script>
